import React, { createContext, useState } from "react";
import Modal from "@app/components/Modal";

const Alert = ({ show, close, header, renderChildren, buttons, size = "md" }) => {
	return (
		<Modal hasCloseButton={true} header={header} buttons={buttons} size={size} show={show} onHide={() => close?.()}>
			{renderChildren?.()}
		</Modal>
	);
};

export const AlertContext = createContext({
	showAlert: null,
});

const AlertContextProvider = ({ children }) => {
	const [alertConfig, setAlertConfig] = useState(null);
	const showAlert = (config) => {
		setAlertConfig(config);
	};
	const closeAlert = () => {
		setAlertConfig(null);
	};

	return (
		<AlertContext.Provider
			value={{
				showAlert,
				closeAlert,
			}}
		>
			<Alert show={!!alertConfig} {...(alertConfig || {})} close={closeAlert} />
			{children}
		</AlertContext.Provider>
	);
};

export default AlertContextProvider;
